import { Chip } from '~/components/elements/Chip'
import { ShopIcon } from '~/components/icons/generated/ShopIcon'
import { buildUrl } from '~/features/shared/search/coordinate/builder/buildUrl'

type Props = {
  id: number
  name: string
  address: string
  zipcode: string
  imageUrl?: string
  coordinatesCount: number
  brands?: {
    id: number
    name: string
    key: string
  }[]
}

export const ShopCard: React.FC<Props> = ({
  id,
  name,
  address,
  zipcode,
  imageUrl,
  coordinatesCount,
  brands = [],
}) => {
  const pcZipcodeAndAddress =
    zipcode && address
      ? `〒${zipcode}｜${address}`
      : zipcode
        ? `〒${zipcode}`
        : address
  const shopDetailPath = `/shop/${id}/`
  return (
    <div className="flex gap-x-[10px] px-4 py-3 xl:gap-x-[17px] xl:overflow-hidden xl:rounded-[3px] xl:border xl:border-gray-300 xl:bg-white xl:p-6">
      <div className="shrink-0">
        <a
          href={shopDetailPath}
          className="flex size-[55px] items-center justify-center overflow-hidden rounded-[3px] border border-gray-300 bg-white hover:opacity-70 xl:size-[68px]"
          aria-hidden
          tabIndex={-1}
        >
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={name}
              width="55"
              height="55"
              className="object-cover xl:size-[68px]"
            />
          ) : (
            <ShopIcon className="h-7 xl:h-8" />
          )}
        </a>
      </div>
      <div className="min-w-0">
        <div className="xl:flex xl:flex-col xl:gap-y-1 xl:pb-[9px]">
          <h3 className="truncate pt-1 text-[16px] font-bold leading-normal xl:overflow-visible xl:whitespace-normal xl:pt-0">
            <a href={shopDetailPath} className="hover:underline">
              {name}
            </a>
          </h3>
          {pcZipcodeAndAddress && (
            <p className="hidden text-[11px] leading-normal text-gray-600 xl:block">
              {pcZipcodeAndAddress}
            </p>
          )}
          <p className="truncate text-[11px] leading-normal text-gray-600 empty:hidden xl:hidden">
            {address}
          </p>
        </div>
        <p className="hidden xl:block">
          <a
            href={shopDetailPath}
            className="flex items-center gap-x-[2px] text-[11px] hover:underline"
            aria-label={`このショップのスタッフが投稿したコーディネート(${coordinatesCount}件)を見る`}
          >
            <span className="text-[18px] font-bold leading-none">
              {coordinatesCount}
            </span>
            コーディネート
          </a>
        </p>
        {brands.length > 0 && (
          <div className="hidden flex-col gap-y-[5px] pt-[13px] xl:flex">
            <p className="text-[11px] leading-normal text-gray-600">
              取り扱いブランド
            </p>
            <ul className="flex flex-wrap gap-[6px]">
              {brands.map((brand) => (
                <li key={brand.key}>
                  <Chip href={buildUrl({ snapItems: [{ brand }] })} light>
                    {brand.name}
                  </Chip>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}
